import type { UserLocationMarkerInput, UserLocationMarkerState } from "./types";

export default class extends Marko.Component<UserLocationMarkerInput, UserLocationMarkerState> {
  declare calculateOverlayPositionTimeout: NodeJS.Timeout | undefined;
  onCreate() {
    this.state = {
      isTourtipOpen: false,
      overlayPositionOffset: 0,
      placement: "top",
    };
    this.calculateOverlayPositionTimeout = undefined;
  }

  // Calculate where to position the overlay circle to keep the user's location at the center
  calculateOverlayPosition() {
    clearTimeout(this.calculateOverlayPositionTimeout);
    this.calculateOverlayPositionTimeout = setTimeout(() => {
      const userLocationMarkerElement = this.el?.querySelector(".user-location-marker");
      const { overlayRadius } = this.input || {};
      if (userLocationMarkerElement && overlayRadius) {
        const userLocationMarkerHeight = userLocationMarkerElement.getBoundingClientRect().height;
        this.state.overlayPositionOffset = overlayRadius / 2 - userLocationMarkerHeight / 2;
      }
    }, 0);
  }

  onMount() {
    this.calculateOverlayPosition();
  }

  onUpdate() {
    this.calculateOverlayPosition();
  }

  openTourtip(event: Event) {
    event.stopPropagation();
    this.state.isTourtipOpen = true;
    this.state.placement = "bottom";
  }

  onTourtipClose(event?: { originalEvent: Event }) {
    event?.originalEvent?.stopPropagation();
    this.state.isTourtipOpen = false;
    this.state.placement = "bottom";
  }

  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this.openTourtip(event);
    }
  }
}
